import { getSettings } from "core-integration/src/store/game/reducers";
import { formatTime } from "plos/src/components/CountdownTimer/utils";
import HorizontalDivider from "plos/src/components/HorizontalDivider";
import { useCountdown } from "plos/src/hooks";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDateAsTime } from "shared-utils/src/datetime";
import LastUpdated from "../LastUpdated/LastUpdated";
import styles from "./priceChangeDeadline.module.css";

const PriceChangeDeadline = () => {
  const { t } = useTranslation("priceChanges");

  const settings = useSelector(getSettings);
  const nextDeadline = useMemo(
    () =>
      settings?.price_change_deadlines?.[0]
        ? new Date(settings.price_change_deadlines[0])
        : null,
    [settings?.price_change_deadlines?.[0]],
  );

  const timeLeft = useCountdown(nextDeadline);
  return (
    <div className={styles.deadlineContainer}>
      {nextDeadline && (
        <div className={styles.deadlineContainerInner}>
          <div>
            <div className={styles.deadlineInfo}>
              <p>{t("nextPriceChanges", "Next Price Changes Happen in:")}</p>
              {timeLeft && (
                <span className={styles.deadlineCountdown}>
                  <span>{formatTime(timeLeft.hours)}</span>:
                  <span>{formatTime(timeLeft.minutes)}</span>:
                  <span>{formatTime(timeLeft.seconds)}</span>
                </span>
              )}
            </div>
            <p className={styles.deadlineLabel}>
              {t("nextPriceChangeAt", "Next Price Change at:")}{" "}
              {formatDateAsTime(nextDeadline)} {t("localTime", "(Local Time)")}
            </p>
          </div>
          <div className={styles.dividerMobile}>
            <HorizontalDivider />
          </div>
          <LastUpdated />
        </div>
      )}
      <div className={styles.dividerDesktop}>
        <HorizontalDivider />
      </div>
    </div>
  );
};

export default PriceChangeDeadline;
